import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = () => {
  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.017 15.2004C18.1959 15.2004 17.4904 15.7018 17.1896 16.4145H10.2059C9.22402 16.4145 8.42457 15.615 8.42457 14.6331C8.42457 13.6503 9.22311 12.8509 10.2059 12.8509H13.7578C15.5871 12.8509 17.0758 11.3622 17.0758 9.53201C17.0758 7.70186 15.5871 6.21407 13.7578 6.21407H6.77419C6.47338 5.50134 5.76787 5 4.94765 5C3.85462 5 2.96484 5.88888 2.96484 6.98191C2.96484 8.07404 3.85462 8.96291 4.94765 8.96291C5.76787 8.96291 6.47338 8.46157 6.77419 7.74975H13.7578C14.7398 7.74975 15.5392 8.54918 15.5392 9.5311C15.5392 10.5139 14.7398 11.3134 13.7578 11.3134H10.2059C8.37669 11.3134 6.888 12.8021 6.888 14.6322C6.888 16.4624 8.37669 17.9502 10.2059 17.9502H17.1896C17.4904 18.6629 18.1959 19.1642 19.017 19.1642C20.1101 19.1642 20.9998 18.2753 20.9998 17.1823C20.9998 16.0893 20.1101 15.2004 19.017 15.2004Z"
        fill="#A3A3A3"
      />
    </Svg>
  );
};

export default Icon;
